export function setUrlSearchParam(key: string, value: string) {
  const urlParams = new URLSearchParams(location.search);
  urlParams.set(key, value);
  return `?${urlParams.toString()}`;
}

export function addUrlSearchParam(key: string, value: string) {
  return `${location.origin}${location.pathname}${setUrlSearchParam(key, value)}`;
}

export function deleteUrlSearchParam(url: URL, ...keys: string[]) {
  const urlParams = new URL(url).searchParams;
  keys.forEach((k) => urlParams.delete(k));
  return `${url.origin}${url.pathname}?${urlParams.toString()}`;
}

export function getRedirectUrl() {
  const urlParams = new URLSearchParams(location.search);
  return decodeURIComponent(urlParams.get('redirect') || encodeURIComponent('/welcome'));
}

export const fullyQualify = (url: string) => `${location.origin}${url}`;
